import React, { useEffect } from 'react'
import moment from 'moment'
import { useFooter, useMall, useReservation } from '../../../../store'

import './FixedScheduleInfo.scss'

// 날짜·시간이 고정된 행사 매장은 캘린더/시간 선택 없이 인원만 선택
// 가격은 안내용 고정값이며, 실제 결제 금액은 '다음' 클릭 시 가예약 응답 금액(서버 계산)으로 확정
const FIXED_SCHEDULE_MALLS = {
	// 더한옥헤리티지 리추얼 데이 (2026.10.29)
	'6acf08db282b72147ad92932': {
		title: '더한옥헤리티지 리추얼 데이',
		dateTime: '2026-10-29 08:30',
		dateText: '2026.10.29 (목) · 서울 08:30 출발',
		badge: '모집 중',
		optionName: '성인 1인',
		unitPrice: 399000,
		optionDesc: '왕복 버스·점심·도슨트·플로팅 사운드 배스 포함',
		help: '1회 예약 시 최대 4명까지 선택 가능합니다. 5인 이상 단체 예약은 033-823-9500으로 문의해주세요.',
		notice: '본 행사는 최소 30명 이상 모집 시 진행되며, 2026.10.22(목) 18:00까지 인원이 충족되지 않으면 자동 취소 후 전액 환급됩니다.',
		// 정보 입력 단계 (항목명은 어드민 추가정보명과 동일해야 함)
		detail: {
			menuItemName: '점심 메뉴 선택',
			menuHelp: '나무 레스토랑 점심은 1인 1메뉴로 제공됩니다. 동반인 정보는 미리 알려주시면 준비에 도움이 됩니다.',
			menuDescriptions: ['① 영월 황잣 콩국수 & 고사리 만두', '② 동강 다슬기 강된장 비빔밥'],
			requestPlaceholder: '식이 제한 등 전달하실 내용이 있으면 적어주세요.',
			conditionItemName: '진행 조건 확인',
			conditionNotice: '최소 30명 미충족 시 행사가 자동 취소되며, 결제 금액은 전액 환급됩니다.',
			privacyItemName: '개인정보 수집 및 마케팅 활용 동의를 선택해주세요.',
		},
		// 예약 완료 단계
		complete: { notes: ['셔틀버스 탑승 상세 안내는 행사 전 문자로 별도 안내드립니다.', '문의 033-823-9500'] },
	},
}

export const getFixedSchedule = mallId => FIXED_SCHEDULE_MALLS[mallId]

const won = value => `₩${value.toLocaleString('ko-KR')}`

export default function FixedScheduleInfo({ schedule }) {
	const { mall } = useMall()
	const { totalPartySize, setReservation } = useReservation()
	const { setFooter } = useFooter()
	const { people_max: max, people_min: min } = { ...mall }

	useEffect(() => {
		setReservation('dateTime', moment(schedule.dateTime, 'YYYY-MM-DD HH:mm'))
		setFooter('active', true)
	}, [schedule])

	useEffect(() => {
		if (min && (!totalPartySize || totalPartySize < min || totalPartySize > max))
			setReservation('totalPartySize', min)
	}, [min, max])

	const handlePartySize = (value) => {
		const next = totalPartySize + value
		if (next < min || next > max)
			return
		setReservation('totalPartySize', next)
	}

	if (!mall || !totalPartySize)
		return null

	return (
		<div className="fixed-schedule-info-container">
			<div className="title">{schedule.title}</div>
			<div className="date">{schedule.dateText}</div>

			<h2 className="subtitle">
				인원 선택
				{schedule.badge && <span className="badge">{schedule.badge}</span>}
			</h2>
			<div className="option">
				<div>
					<div className="option-name">{schedule.optionName} {won(schedule.unitPrice)}</div>
					<div className="option-desc">{schedule.optionDesc}</div>
				</div>
				<div className="stepper">
					<button type="button" aria-label="빼기" disabled={totalPartySize <= min} onClick={() => handlePartySize(-1)}>−</button>
					<span>{totalPartySize}</span>
					<button type="button" aria-label="더하기" disabled={totalPartySize >= max} onClick={() => handlePartySize(1)}>+</button>
				</div>
			</div>
			<p className="help">{schedule.help}</p>

			<div className="total">
				<span>총 결제 금액</span>
				<b>{won(schedule.unitPrice * totalPartySize)}</b>
			</div>

			<div className="notice">{schedule.notice}</div>
		</div>
	)
}
